import { Style, Fill, Stroke, Text } from 'ol/style';

// Primary color palette
const PRIMARY_COLORS = [
  { stroke: '#FF0000', fill: 'rgba(255,0,0,0.2)' },     // Red
  { stroke: '#0000FF', fill: 'rgba(0,0,255,0.2)' },     // Blue
  { stroke: '#008000', fill: 'rgba(0,128,0,0.2)' },     // Green
  { stroke: '#FFA500', fill: 'rgba(255,165,0,0.2)' },   // Orange
  { stroke: '#800080', fill: 'rgba(128,0,128,0.2)' },   // Purple
  { stroke: '#00FFFF', fill: 'rgba(0,255,255,0.2)' },   // Cyan
  { stroke: '#FF00FF', fill: 'rgba(255,0,255,0.2)' },   // Magenta
  { stroke: '#FFFF00', fill: 'rgba(255,255,0,0.2)' },   // Yellow
  { stroke: '#8B4513', fill: 'rgba(139,69,19,0.2)' },   // Brown
  { stroke: '#2F4F4F', fill: 'rgba(47,79,79,0.2)' },    // Dark Slate Gray

  { stroke: '#DC143C', fill: 'rgba(220,20,60,0.2)' },   // Crimson
  { stroke: '#00CED1', fill: 'rgba(0,206,209,0.2)' },   // Dark Turquoise
  { stroke: '#9400D3', fill: 'rgba(148,0,211,0.2)' },   // Dark Violet
  { stroke: '#FF1493', fill: 'rgba(255,20,147,0.2)' },  // Deep Pink
  { stroke: '#1E90FF', fill: 'rgba(30,144,255,0.2)' },  // Dodger Blue
  { stroke: '#228B22', fill: 'rgba(34,139,34,0.2)' },   // Forest Green
  { stroke: '#FFD700', fill: 'rgba(255,215,0,0.2)' },   // Gold
  { stroke: '#ADFF2F', fill: 'rgba(173,255,47,0.2)' },  // Green Yellow
  { stroke: '#FF4500', fill: 'rgba(255,69,0,0.2)' },    // Orange Red
  { stroke: '#4682B4', fill: 'rgba(70,130,180,0.2)' }   // Steel Blue
];

let colorIndex = 0;

function normalizeColorValue(color) {
  return String(color || '').trim().toUpperCase();
}

/**
 * Returns next color in cycle
 */
export function getNextColor() {
  const color = PRIMARY_COLORS[colorIndex % PRIMARY_COLORS.length];
  colorIndex++;
  return color;
}

/**
 * Returns OpenLayers style using next color
 */
export function getNextStyle() {
  const color = getNextColor();

  return new Style({
    stroke: new Stroke({
      color: color.stroke,
      width: 2
    }),
    fill: new Fill({
      color: color.fill
    })
  });
}

/** Eerste kleur uit het palet die nog niet gebruikt is (hex). */
export function peekNextUnusedColor(existingColors = []) {
  const used = new Set((existingColors || []).map(normalizeColorValue).filter(Boolean));
  const next = PRIMARY_COLORS.find(c => !used.has(normalizeColorValue(c.stroke)));
  return (next || PRIMARY_COLORS[existingColors.length % PRIMARY_COLORS.length]).stroke;
}

/**
 * Reset color cycle (optional use)
 */
export function resetColorCycle() {
  colorIndex = 0;
}

export function syncColorCycle(existingColors = []) {
  if (!Array.isArray(existingColors) || existingColors.length === 0) {
    colorIndex = 0;
    return;
  }

  const usedColors = new Set(
    existingColors
      .map(normalizeColorValue)
      .filter(Boolean)
  );

  const nextIndex = PRIMARY_COLORS.findIndex(color => !usedColors.has(normalizeColorValue(color.stroke)));
  colorIndex = nextIndex >= 0 ? nextIndex : existingColors.length % PRIMARY_COLORS.length;
}

export function createStyleFromColor(hexColor, labelText = '') {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  return new Style({
    stroke: new Stroke({
      color: hexColor,
      width: 2
    }),
    fill: new Fill({
      color: `rgba(${r},${g},${b},0.2)`
    }),
    text: labelText === '' ? undefined : new Text({
      text: String(labelText),
      font: 'bold 13px Arial, sans-serif',
      placement: 'point',
      overflow: true,
      textAlign: 'center',
      textBaseline: 'middle',
      fill: new Fill({
        color: '#FFFFFF'
      }),
      stroke: new Stroke({
        color: 'rgba(0,0,0,0.85)',
        width: 3
      })
    })
  });
}
